<template>
  <v-sheet>
    <TitleModal 
      v-model="showCreateTitleModal"
      :titles="titles"
      @save="saveTitle"
    />
    <div>
      <Title 
        v-for="(title, index) in savedTitles" 
        :key="`${title.title_id}_${index}`"
        :title="title"
        :index="index"
        :titles="titles"
        @edit="editTitle"
        @delete="deleteTitle"
      />
    </div>
  </v-sheet>
</template>

<script>
import Title from '../../components/title/Title';
import TitleModal from '../../components/title/TitleModal';

export default {
  beforeRouteUpdate(to, from, next) {
    this.$axios.get('/api/marketplace/' + to.params.id)
    .then(payload => {
      this.savedTitles = payload.data
    })
    .catch(err => console.warn(err.message));
    
    next();
  }, 
  props: {
    titles: {
      type: Array,
      default: () => ([])
    }
  },
  components: {
    Title,
    TitleModal
  },
  data: () => ({
    showCreateTitleModal: false,
    savedTitles: [],
  }),
  created() {
    this.$axios.get('/api/marketplace/' + this.$route.params.id)
    .then(payload => {
      this.savedTitles = payload.data
    })
    .catch(err => console.warn(err.message))
  },
  methods: {
    async saveTitle(title) {
      const data = { 
        ...title,
        marketplace_id: this.$route.params.id
      }

      try {
        await this.$axios.post('/api/marketplace/add-title', data);
        this.savedTitles.push(data);
        this.$toasted.success('Title seccessfully added');
      } catch(err) {
        this.$toasted.error(err.message);
      }
    },
    async editTitle(title, index) {
      const data = { 
        ...title,
        marketplace_id: this.$route.params.id
      }

      try {
        await this.$axios.put('/api/marketplace/edit-title', data);
        this.$set(this.savedTitles, index, data);
        this.$toasted.success('Title seccessfully edited');
      } catch(err) {
        this.$toasted.error(err.message);
      }
    },
    async deleteTitle(title, index) {
       const data = { 
        ...title,
        marketplace_id: this.$route.params.id
      }

      try {
        await this.$axios.delete('/api/marketplace/delete-title/' + data.marketplace_id + '/' + data.title_id);
        this.$delete(this.savedTitles, index);
        this.$toasted.success('Title seccessfully deleted');
      } catch(err) {
        this.$toasted.error(err.message);
      }
    }
  },
}
</script>